export const apiRest = process.env.REACT_APP_API_REST;
